import styled from "styled-components";
import { BASIC_BLACK, BASIC_WHITE } from "../../constants/colors";

type Props = {
  color: string;
  text: string;
  textColor?: string;
  rounded?: boolean;
  size?: "sm" | "md";
};

export const Badge: React.FC<Props> = ({
  color,
  text,
  textColor,
  rounded = true,
  size = "md",
}) => {
  return (
    <BadgeContainer color={color} $rounded={rounded}>
      <BadgeText color={color} size={size} $textColor={textColor}>
        {text}
      </BadgeText>
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div<{ $rounded: boolean }>`
  width: 100px;
  padding: 0;
  margin: 0;
  align-items: center;
  text-align: center;
  border-radius: ${({ $rounded }) => ($rounded ? "100px" : "5px")};
  background-color: ${({ color }) => color};
`;

const BadgeText = styled.p<{ size: "sm" | "md"; $textColor?: string }>`
  padding: ${({ size }) => (size === "sm" ? "7px 5px" : "10px 0 8px")};
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  line-height: 1;
  color: ${({ color, $textColor }) =>
    $textColor !== undefined
      ? $textColor
      : color === "transparent"
        ? BASIC_BLACK
        : BASIC_WHITE};
`;
